import * as React from "react";
import { useState, useEffect, useContext} from "react"
import PageContainer from "../core/PageContainer";
import ModernCard from "../core/ModernCard";

import Breadcrumbs from "../core/Breadcrumbs";
import MonthlyServices from "../quote_calculator/MonthlyService"
import MonthlyProduct from "../quote_calculator/MonthlyProduct"
import SingleCharge from "../quote_calculator/SingleCharge"
import { Link } from "react-router-dom"
import { jfetch, toast } from "../../utils";
import { ResponsiveLine } from '@nivo/line'
import { ResponsivePie } from '@nivo/pie'
import Modal from "../core/Modal";
import NumberFormat from "react-number-format";
import useDashboard from "../../hooks/useDashboard";

import {arrayMove, SortableContainer, SortableElement} from 'react-sortable-hoc';

interface IProps {
  userContext:any;
}

function Dashboard(props:IProps){
  const [calculators, setCalculators] = useState([])
  const [graphData, setGraphData] = useState([])
  const [pieData, setPieData] = useState([])
  const iconStyle = {
    width: '118px',
    height: '118px',
    paddingTop: '20px',
    color: 'white',
    backgroundColor: 'rgb(19, 104, 170)',
    borderRadius: '50%'
  }


  useEffect(() => {
    jfetch
      .get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator`)
      .then((resp) => {
        setCalculators(resp.quote_calculators)
      }) 
      .catch((err) => {
      })
  }, [])

  useEffect(() => {
    jfetch
    .get(`/organizations/${props.userContext.org.id}/quote_calculator/quotes_stats`)
    .then((resp) => {
      setGraphData(resp.data)
      setPieData(resp.profit_breakdown)
    })
  }, [])

  const event = new Event('quote_change');
  useEffect(() => {
    window.document.dispatchEvent(event);
  }, [])

  function passCheck(){
    if(graphData != undefined){
      let a = graphData[0]["data"].reduce((a,b) => a+b.y,0)
      let b = graphData[1]["data"].reduce((a,b) => a+b.y,0)
      return (a+b) > 0
    }
    else{
      return false
    }
  }

  return (
    <PageContainer>   
      <Breadcrumbs crumbs={[{ label: "Quoting Dashboard" }]} />
      <div className="row">
        <div className="col-lg-6">
          <h3 className="dashboard-sec">Product and Service Items</h3>
        </div>
        <div className="col-lg-6 text-right">
          <Link to="/quote_calculator/new">
            <button className="btn btn-primary btn-sm new-calculator" style={{marginRight:'10px'}}> 
              <i className="fa fa-plus"/> New Calculator
            </button>
          </Link>
          <SettingsModal userContext={props.userContext} />
        </div>        
      </div>
      <div className="row" style={{"marginBottom":"30px"}}>
        <div className="col-lg-4 quote-counts text-center">
          <ModernCard>
            <MonthlyServices userContext={props.userContext}/>
          </ModernCard>
        </div>
        <div className="col-lg-4 quote-counts text-center">
          <ModernCard>
            <MonthlyProduct userContext={props.userContext}/>            
          </ModernCard>
        </div> 
        <div className="col-lg-4 quote-counts text-center">
          <ModernCard>
            <SingleCharge userContext={props.userContext} />
          </ModernCard>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <h3 className="dashboard-sec">Calculator Templates</h3>
        </div>
      </div> 
      <div className="row" style={{marginBottom:'30px'}}>
        { calculators.map((c) => {
          return (
            <div className="col-lg-4 text-center quote-calcs" key={c.id}>
              <ModernCard>
                {/* {!(c.global == true && c.organization_id != props.userContext.org.id) && (  */}
                <Link to={`/quote_calculator/${c.id}/quotes/`}>
                  <div>
                    <div>
                      <i className={`fa ${c.icon}`} style={iconStyle} />
                    </div>
                    <div>
                      {c.name}
                    </div>
                  </div>
                </Link>
                {/* )} */}
              </ModernCard>
            </div>          
          )       
        })
        }
      </div>
      <div className="row">
        <div className="col-lg-12">
          <h3 className="dashboard-sec">Statistics</h3>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6">
          <ModernCard>
            <h3>New MRR vs Profit</h3>
            <div style={{height:'450px'}}>
              { graphData.length > 0 && passCheck() && ( 
                <ResponsiveLine
                  data={graphData}
                  margin={{ top: 20, right: 5, bottom: 50, left: 70 }}
                  xScale={{ type: 'point' }}
                  yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: false, reverse: false }}
                  yFormat={ (value) => `$ ${value.toLocaleString('en-us', {minimumFractionDigits: 2})}` }
                  axisTop={null}
                  axisRight={null}
                  axisBottom={{
                      orient: 'bottom',
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      legend: 'months',
                      legendOffset: 36,
                      legendPosition: 'middle'
                  }}
                  axisLeft={{
                      orient: 'left',
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      legend: '',
                      legendOffset: -60,
                      legendPosition: 'middle',
                      format: value => 
                      `$ ${value.toLocaleString('en-us', {minimumFractionDigits: 0})}`
                  }}
                  colors={{ scheme: 'nivo' }}
                  pointSize={10}
                  pointColor={{ theme: 'background' }}
                  pointBorderWidth={2}
                  pointBorderColor={{ from: 'serieColor' }}
                  pointLabel="y"
                  pointLabelYOffset={-12}
                  useMesh={true}
                  legends={[
                    {
                        anchor: 'bottom-right',
                        direction: 'column',
                        justify: false,
                        translateX: 100,
                        translateY: 0,
                        itemsSpacing: 0,
                        itemDirection: 'left-to-right',
                        itemWidth: 80,
                        itemHeight: 20,
                        itemOpacity: 0.75,
                        symbolSize: 12,
                        symbolShape: 'circle',
                        symbolBorderColor: 'rgba(0, 0, 0, .5)',
                        effects: [
                            {
                                on: 'hover',
                                style: {
                                    itemBackground: 'rgba(0, 0, 0, .03)',
                                    itemOpacity: 1
                                }
                            }
                        ]
                    }
                ]}        
              />)}

            </div>
          </ModernCard>
        </div>
        <div className="col-lg-6">
          <ModernCard>
            <h3>Monthly Profits Breakdown</h3>
            <div style={{height:'450px'}}>
              { pieData.length > 0 && (
                <ResponsivePie
                  data={pieData}
                  margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                  padAngle={0.7}
                  cornerRadius={3}
                  colors={{ scheme: 'nivo' }}
                  sliceLabel={(d) => {
                    return  `$ ${parseFloat(d.value.toString()).toLocaleString('en-us', {minimumFractionDigits: 2})}`
                  }}
                  borderWidth={1}
                  borderColor={{ from: 'color', modifiers: [ [ 'darker', 0.2 ] ] }}
                  radialLabelsSkipAngle={10}
                  radialLabelsTextXOffset={6}
                  radialLabelsTextColor="#333333"
                  radialLabelsLinkOffset={0}
                  radialLabelsLinkDiagonalLength={16}
                  radialLabelsLinkHorizontalLength={24}
                  radialLabelsLinkStrokeWidth={1}
                  radialLabelsLinkColor={{ from: 'color' }}
                  slicesLabelsSkipAngle={10}
                  slicesLabelsTextColor="#333333"
                  animate={true}
                  motionStiffness={90}
                  motionDamping={15}
                  tooltipFormat={(d) => {
                    return  `$ ${(parseFloat(d.toString())).toLocaleString('en-us', {minimumFractionDigits: 2})}`
                  }}
                  defs={[
                      {
                          id: 'dots',
                          type: 'patternDots',
                          background: 'inherit',
                          color: 'rgba(255, 255, 255, 0.3)',
                          size: 4,
                          padding: 1,
                          stagger: true
                      },
                      {
                          id: 'lines',
                          type: 'patternLines',
                          background: 'inherit',
                          color: 'rgba(255, 255, 255, 0.3)',
                          rotation: -45,
                          lineWidth: 6,
                          spacing: 10
                      }
                  ]}
                  legends={[
                      {
                          anchor: 'bottom',
                          direction: 'row',
                          translateY: 56,
                          itemWidth: 100,
                          itemHeight: 18,
                          itemTextColor: '#999',
                          symbolSize: 18,
                          symbolShape: 'circle',
                          effects: [
                              {
                                  on: 'hover',
                                  style: {
                                      itemTextColor: '#000'
                                  }
                              }
                          ]
                      }
                  ]}
              />)}
            </div>
          </ModernCard>
        </div>
      </div>
    </PageContainer>
  )
}

interface SM{
  userContext:any;
}

function SettingsModal(props:SM){
  const [showModal, setShowModal] = useState(false)
  const [payRate, setPayRate] = useState(0)
  const [billRate, setBillRate] = useState(0)
  const [ROI, setROI] = useState(12)
  const {categories, setCategories} = useDashboard()


  useEffect(() => {
    jfetch
    .get(`/organizations/${props.userContext.org.id}`)
    .then((resp) => {
      let s = resp["data"]["attributes"]["settings"]
      if(s){
        if(s.hasOwnProperty("laborPayRate")){
          setPayRate(s["laborPayRate"])
        }
        if(s.hasOwnProperty("laborBillRate")){
          setBillRate(s["laborBillRate"])
        }
        if(s.hasOwnProperty("quoteROI")){
          setROI(s["quoteROI"])
        }
      }
    })
  }, [])

  return (
    <>
      <button className="btn btn-primary btn-sm" onClick={() => setShowModal(true)}>
        <i className="fa fa-cog"/> Settings
      </button>
      <div className="text-center">
        <Modal
          title={"Calculator Templates"}
          open={showModal}
          close={() => setShowModal(false)}
          submittable={true}
          isLarge={true}
          disallowClickOutside={true}
          submitText="Update"
          onSubmit={() => {
            let org = {
              organization : {
                laborPayRate:payRate,
                laborBillRate:billRate,
                quoteROI:ROI
              }
            }
            jfetch
            .post(`/organizations/${props.userContext.org.id}/update_settings`, org)
            .then((resp) => {
              setShowModal(false);
              toast.success("Settings have been updated")
            })
          }}
        >       
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-6 text-left">
                <label>Labor Burden Rate</label>
                <NumberFormat 
                  value={payRate}
                  className="form-control"
                  displayType={'input'} 
                  fixedDecimalScale={true} 
                  decimalScale={2}
                  prefix={'$'} 
                  onValueChange={(values) => {
                    setPayRate(values.floatValue)
                  }}
                />
                <label>Labor Billable Rate</label>
                <NumberFormat 
                  value={billRate}
                  className="form-control"
                  displayType={'input'} 
                  fixedDecimalScale={true} 
                  decimalScale={2}
                  prefix={'$'} 
                  onValueChange={(values) => {
                    setBillRate(values.floatValue)
                  }}
                />
                <label>HaaS ROI (months)</label>
                <NumberFormat 
                  value={ROI}
                  className="form-control"
                  displayType={'input'} 
                  fixedDecimalScale={true} 
                  decimalScale={0}
                  onValueChange={(values) => {
                    setROI(values.floatValue)
                  }}
              />
              </div>
              <CategoryList userContext={props.userContext} />
            </div>          
          </div>
        </Modal>
        </div>
    </>
  )
}

function CategoryList(props){
  const {categories, setCategories} = useDashboard()
  const [allCategories, setAllCategories] = useState(categories)
  // const [categories, setCategories] = useState([])
  const [text, setText] = useState('')


  const SortableItem = SortableElement(({value}) => (
    <div style={{zIndex:999999, backgroundColor:'#e6e7e7'}}>
      <CategoryItem key={value.id} category={value} delete_category={delete_category} org_id={props.userContext.org.id} />
    </div>
  ) );

  const SortableList = SortableContainer(({items}) => {
    return (
      <div>
        { categories.map((category, index) => {
          return (
            <SortableItem key={category.id} index={index} value={category} />
          )
        })}
      </div>
    );
  });

  useEffect(() => {
    get_categories()
  }, [])
  function create_category(){
    jfetch  
    .post(`/organizations/${props.userContext.org.id}/quote_calculator/categories`, {category:{name:text}})
    .then((resp) => {
      get_categories()
      setText('')
    })
  }
  function delete_category(id){
    jfetch
    .delete(`/organizations/${props.userContext.org.id}/quote_calculator/categories/${id}`)
    .then((resp) => {
      get_categories()
    })
  }
  function get_categories(){
    jfetch
    .get(`/organizations/${props.userContext.org.id}/quote_calculator/categories`)
    .then((resp) => {
      setCategories(resp["categories"])
      // setAllCategories(resp["categories"])
    })
  }

  const onSortEnd = ({oldIndex, newIndex}) => {
    let new_order = arrayMove([...categories], oldIndex, newIndex)
    setCategories(new_order)
    jfetch.post(`/organizations/${props.userContext.org.id}/quote_calculator/categories/reorder`, {categories:new_order})
    .then((resp) => {
      // console.log('resp:', resp)
    })
  };

  return (
    <div className="col-lg-6 text-left">
      <label>Categories</label>
      <input type="text" value={text} className="form-control" onChange={(e) => setText(e.target.value)} />
      <div style={{textAlign:'right'}}>
        <button className="btn btn-primary btn-sm" onClick={create_category}>Add</button>
      </div>
      <div>{categories.length} of {categories.length}</div>
      <div style={{height:'450px', overflowY:'scroll', backgroundColor:'#d7f5f7'}}>
        <SortableList items={categories} onSortEnd={onSortEnd} pressDelay={100} />
      </div>
    </div>
  )
}

function CategoryItem(props){
  const [edit, setEdit] = useState(false)
  const [name, setName] = useState(props.category.name)

  function toggle_edit(){

    if(edit){
      update_category()
    }

    setEdit(!edit)
  }

  function update_category(){
    jfetch  
    .patch(`/organizations/${props.org_id}/quote_calculator/categories/${props.category.id}`, {category:{name:name}})
    .then((resp) => {
      // console.log('it updated!')
    })
  }

  return (
    <div 
      key={props.category.id} 
      className="qc-category" 
      style={{color:'#7b7b7b', paddingLeft:'10px', borderBottom:'1px solid white', paddingTop:'7px', paddingBottom:'7px', backgroundColor:'#d9eff1', fontSize:'17px'}}
    >
      { edit ? (
        <a onClick={toggle_edit} style={{cursor:'pointer'}}>
          <i className="fa fa-floppy-o" style={{marginRight:'5px', color:'rgb(19, 104, 170)'}}/>
        </a>  
      ) : (
        <a onClick={toggle_edit} style={{cursor:'pointer'}}>
          <i className="fa fa-pencil" style={{marginRight:'5px', color:'rgb(19, 104, 170)'}}/>
        </a>  
      )}                   
        { edit ? (
          <input value={name} style={{display:'inline-flex', width:'65%'}} onChange={(e) => setName(e.target.value)} />
        ) : (
          <>{name}</>
        )}
      <a onClick={() => props.delete_category(props.category.id)} style={{cursor:'pointer'}}>
        <i className="fa fa-trash" style={{marginLeft:'5px', color:'#d0021b'}}/>
      </a>       
    </div>
  )
}

export default Dashboard



// WEBPACK FOOTER //
// ./app/javascript/components/quote_calculator/Dashboard.tsx